/* MEE BARSA — Collection page interactions
   - Menu drawer: click only, never hover (Anjali's rule, same as hero/product page)
   - Filter drawer: mobile-only slide-in panel wrapping the same <form>
   - Filters auto-apply on change (checkboxes + sort) — progressive enhancement,
     the <form> still works with a plain "Apply" submit if JS fails to load
   - Scroll-reveal for headings/cards, matching homepage/product-page treatment
*/
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="mbColMenuBtn-"]').forEach(function (btn) {
    var id = btn.id.replace('mbColMenuBtn-', '');
    var drawer = document.getElementById('mbColDrawer-' + id);
    var scrim = document.getElementById('mbColScrim-' + id);
    var closeBtn = document.getElementById('mbColDrawerClose-' + id);
    if (!drawer || !scrim) return;

    var lastFocus = null;
    var open = function () {
      lastFocus = document.activeElement;
      drawer.classList.add('open');
      scrim.classList.add('show');
      drawer.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      window.setTimeout(function () { drawer.focus(); }, 50);
    };
    var close = function () {
      drawer.classList.remove('open');
      scrim.classList.remove('show');
      drawer.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    btn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
      if (e.key === 'Tab' && drawer.classList.contains('open')) {
        var focusable = drawer.querySelectorAll('a[href],button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  });

  document.querySelectorAll('[id^="mbColFilterToggle-"]').forEach(function (btn) {
    var id = btn.id.replace('mbColFilterToggle-', '');
    var form = document.getElementById('mbColFilterForm-' + id);
    var closeBtn = document.getElementById('mbColFiltersClose-' + id);
    if (!form) return;
    var lastFilterFocus = null;

    function openFilters() {
      lastFilterFocus = document.activeElement;
      form.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) window.setTimeout(function () { closeBtn.focus(); }, 50);
    }
    function closeFilters() {
      form.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFilterFocus && lastFilterFocus.focus) lastFilterFocus.focus();
    }
    btn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && form.classList.contains('open')) closeFilters();
      if (e.key === 'Tab' && form.classList.contains('open')) {
        var focusable = form.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled]),a[href]');
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  });

  // auto-apply filters/sort on change
  document.querySelectorAll('.mb-col-filters').forEach(function (form) {
    form.querySelectorAll('input[type="checkbox"], input[type="number"], select.mb-col-sort').forEach(function (el) {
      el.addEventListener('change', function () {
        form.submit();
      });
    });
  });

  // scroll reveal
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  document.querySelectorAll('.mb-col-reveal').forEach(function (el) {
    io.observe(el);
  });
});
